module.exports = __webpack_public_path__ + "static/buyer-orders-d303e22881af4f86e8360058e65d59ec.gif";